import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const ConfirmModal = ({
  open,
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  onConfirm,
  onCancel,
}) => {
  // ESC closes (treated as cancel)
  useEffect(() => {
    if (!open) return undefined;
    const handler = (e) => {
      if (e.key === 'Escape') onCancel();
      if (e.key === 'Enter') onConfirm();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, onCancel, onConfirm]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center px-6"
      role="dialog"
      aria-modal="true"
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-ink/40 animate-fade"
        onClick={onCancel}
        aria-hidden
      />

      {/* Card */}
      <div className="relative w-full max-w-md bg-paper-soft border border-hairlineStrong shadow-[0_24px_60px_-24px_rgba(26,22,17,0.4)] animate-rise">
        <div className="flex items-start justify-between px-7 pt-7 pb-3">
          <p className="eyebrow text-ink-muted">
            {danger ? 'Confirm deletion' : 'Confirm'}
          </p>
          <button
            type="button"
            onClick={onCancel}
            aria-label="Close"
            className="text-ink-muted hover:text-ink transition-colors -mt-1 -mr-1"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="px-7 pb-6">
          <h2 className="font-display text-2xl md:text-3xl leading-tight">
            {title}
          </h2>
          {description && (
            <p className="font-serif text-ink-soft mt-4 leading-relaxed">
              {description}
            </p>
          )}
        </div>

        <div className="rule" />

        <div className="px-7 py-5 flex justify-end gap-4">
          <button type="button" onClick={onCancel} className="btn-outline">
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={
              danger
                ? 'inline-flex items-center gap-2 px-6 py-3 bg-saffron text-paper font-mono text-[12px] font-medium tracking-[0.16em] uppercase border border-saffron hover:bg-saffron-deep hover:border-saffron-deep transition-colors'
                : 'btn-ink'
            }
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
